import { Text } from '@components/primitives';
import React from 'react';
import { useTranslation } from 'react-i18next';

function LoginWelcomeTxt(): React.JSX.Element {
  const { t } = useTranslation('common');

  return (
    <Text testID="txtLoginWelcome" alignSelf="stretch" textAlign="left" variant="lg-bold">
      {t('login.welcome')}
    </Text>
  );
}

export default LoginWelcomeTxt;
